export default __webpack_public_path__ + "static/media/Twitter and ALO.5f0ec0fe.png";